import { LaunchDarklyClientProvider } from "@openfeature/launchdarkly-client-provider";
import { OpenFeature } from "@openfeature/react-sdk";

const clientEnvKey = process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_KEY || "";

const ldOptions = {
  streaming: true,
};

export const initializeLaunchDarkly = async () => {
  // set up Launch Darkly
  const ldOpenFeatureProvider = new LaunchDarklyClientProvider(
    clientEnvKey,
    ldOptions
  );

  await OpenFeature.setProviderAndWait(ldOpenFeatureProvider);
};

export const getLaunchDarklyFlag = (flagName: string): boolean => {
  const LDFlagClient = OpenFeature?.getClient();
  return LDFlagClient?.getBooleanValue(flagName, false);
};
